import axios from "axios";
import React, { useEffect, useState } from "react";
import { dashboardUser } from "../../api";
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  const navigate = useNavigate();
  const [dashboard, setDashboard] = useState(null);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const fetchDashboard = async () => {
      try {
        // 👇 get full user object from localStorage
        const storedUser = localStorage.getItem("user");
        if (!storedUser) {
          setMessage("❌ No user found, please login.");
          navigate("/login"); 
          return;
        }

        const user = JSON.parse(storedUser);
        const user_token = user.user_token; // 👈 pick token

        if (!user_token) {
          setMessage("❌ No user token found, please login.");
          navigate("/login");
          return;
        }

        // call API
        const res = await dashboardUser({ user_token });

        setDashboard(res.data.dashboard);
        setMessage("✅ Dashboard data fetched");
      } catch (err) {
        console.error(err);
        setMessage(`❌ ${err.response?.data?.message || "Something went wrong"}`);
      }
    };

    fetchDashboard();
  }, [navigate]);   
    return (
    <div className="main-content">
      <div className="main-content-inner">
        <div className="main-content-wrap">
          <div className="tf-container">
            <div className="row">
              <h3 style={{ marginBottom: "0px", paddingBottom: "0px" }}>Summary</h3>
              <p style={{ marginTop: "0px", fontSize: "2rem", marginBottom: "15px", color: "#555" }}>
                Your Revenue Summary
              </p>

              {/* Revenue Cards */}
              <div className="col-lg-12">
                <div className="flex gap24 mb-32 flex-md-row flex-column">
                  <div className="w-100">
                    <div className="wg-card style-1 bg-Primary mb-25">
                      <div
                        style={{ display: "flex", alignItems: "center", gap: "0.5rem", marginBottom: "5px" }}
                      >
                        <div
                          className="card-label f12-medium text-White"
                          style={{ fontSize: "2.85rem", fontWeight: "500", color: "white" }}
                        >
                          Today Revenue
                        </div>
                      </div>
                      <div className="content">
                        <div>
                          <h6 className="counter text-White">${dashboard?.todayTransactionAmount || 0}</h6>
                        </div>
                      </div>
                    </div>

                    <div className="wg-card">
                      <div
                        style={{ display: "flex", alignItems: "center", gap: "0.5rem", marginBottom: "5px" }}
                      >
                        <div
                          className="card-label f12-medium text-black"
                          style={{ fontSize: "2.85rem", fontWeight: "500", color: "black" }}
                        >
                          This week revenue
                        </div>
                      </div>
                      <div className="content">
                        <div>
                          <h6 className="counter text-black">${dashboard?.weeklyTransactionAmount || 0}</h6>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="w-100">
                    <div className="wg-card mb-25">
                      <div
                        style={{ display: "flex", alignItems: "center", gap: "0.5rem", marginBottom: "5px" }}
                      >
                        <div
                          className="card-label f12-medium text-black"
                          style={{ fontSize: "2.85rem", fontWeight: "500", color: "black" }}
                        >
                          This month revenue
                        </div>
                      </div>
                      <div className="content">
                        <div>
                          <h6 className="counter text-black">${dashboard?.monthTransactionAmount || 0}</h6>
                        </div>
                      </div>
                    </div>

                    <div className="wg-card style-1 bg-YellowGreen">
                      <div
                        style={{ display: "flex", alignItems: "center", gap: "0.5rem", marginBottom: "5px" }}
                      >
                        <div
                          className="card-label f12-medium text-black"
                          style={{ fontSize: "2.85rem", fontWeight: "500", color: "black" }}
                        >
                          All time revenue
                        </div>
                      </div>
                      <div className="content">
                        <div>
                          <h6 className="counter text-black">${dashboard?.totalTransactionAmount || 0}</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <h3 style={{ marginBottom: "0px", paddingBottom: "0px" }}>Send Summary</h3>
              <p style={{ marginTop: "0px", fontSize: "2rem", marginBottom: "15px", color: "#555" }}>
                Your Expenses Summary
              </p>
                <div className="flex gap24 mb-32 flex-md-row flex-column">
                  <div className="w-100">
                    <div className="wg-card style-1 bg-Primary mb-25">
                      <div
                        style={{ display: "flex", alignItems: "center", gap: "0.5rem", marginBottom: "5px" }}
                      >
                        <div
                          className="card-label f12-medium text-White"
                          style={{ fontSize: "2.85rem", fontWeight: "500", color: "white" }}
                        >
                          Available Balance
                        </div>
                      </div>
                      <div className="content">
                        <div>
                          <h6 className="counter text-White">${dashboard?.payoutSummary?.available || 0}</h6>
                        </div>
                      </div>
                    </div>

                    <div className="wg-card">
                      <div
                        style={{ display: "flex", alignItems: "center", gap: "0.5rem", marginBottom: "5px" }}
                      >
                        <div
                          className="card-label f12-medium text-black"
                          style={{ fontSize: "2.85rem", fontWeight: "500", color: "black" }}
                        >
                          Total Add Send
                        </div>
                      </div>
                      <div className="content">
                        <div>
                          <h6 className="counter text-black">${dashboard?.payoutSummary?.totalAdd || 0}</h6>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="w-100">
                    <div className="wg-card mb-25">
                      <div
                        style={{ display: "flex", alignItems: "center", gap: "0.5rem", marginBottom: "5px" }}
                      >
                        <div
                          className="card-label f12-medium text-black"
                          style={{ fontSize: "2.85rem", fontWeight: "500", color: "black" }}
                        >
                          Total Transfer send
                        </div>
                      </div>
                      <div className="content">
                        <div>
                          <h6 className="counter text-black">${dashboard?.payoutSummary?.totalSend || 0}</h6>
                        </div>
                      </div>
                    </div>

                    <div className="wg-card style-1 bg-YellowGreen">
                      <div
                        style={{ display: "flex", alignItems: "center", gap: "0.5rem", marginBottom: "5px" }}
                      >
                        <div
                          className="card-label f12-medium text-black"
                          style={{ fontSize: "2.85rem", fontWeight: "500", color: "black" }}
                        >
                          Hold
                        </div>
                      </div>
                      <div className="content">
                        <div>
                          <h6 className="counter text-black">${dashboard?.payoutSummary?.holdAmount || 0}</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                                <div className="flex gap24 mb-32 flex-md-row flex-column">
                                    <div className="wg-box gap16">
                                        <div>
                                            <div className="title mb-12">
                                                <div className="label-01">Receive Revenue</div>
                                            </div>
                                            
                                        </div>
                                        <table className="tab-sell-order">
                                            <thead>
                                                <tr>
                                                    <th className="f14-regular text-Gray">Name</th>
                                                    <th className="f14-regular text-Gray">Amount</th>
                                                    <th className="f14-regular text-Gray">Percentage</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td className="f14-regular"><img src="/images/bep20icone.png" style={{maxHeight: "30px", maxWidth: "30px", marginRight: '5px'}}/>BEP20</td>
                                                    <td className="f14-regular" style={{alignSelf: "end"}}>${dashboard?.chainDistribution?.BEP20?.amount || 0}</td>
                                                    <td className="f14-regular">{dashboard?.chainDistribution?.BEP20?.percentage || 0}%</td>
                                                </tr>
                                                <tr>
                                                    <td className="f14-regular"><img src="/images/TRC20icon.png" style={{maxHeight: "30px", maxWidth: "30px", marginRight: '5px'}}/>TRC20</td>
                                                    <td className="f14-regular">${dashboard?.chainDistribution?.TRC20?.amount || 0}</td>
                                                    <td className="f14-regular">{dashboard?.chainDistribution?.TRC20?.percentage || 0}%</td>
                                                </tr>
                                                <tr>
                                                    <td className="f14-regular"><img src="/images/ERC20icone.png" style={{maxHeight: "30px", maxWidth: "30px", marginRight: '5px'}}/>ERC20</td>
                                                    <td className="f14-regular">${dashboard?.chainDistribution?.ERC20?.amount || 0}</td>
                                                    <td className="f14-regular">{dashboard?.chainDistribution?.ERC20?.percentage || 0}%</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        
                                    </div>
                                    <div className="wg-box gap16 bg-YellowGreen">
                                        <div>
                                            <div className="title mb-12">
                                                <div className="label-01">Send Order</div>
                                            </div>
                                        </div>
                                        <table className="tab-sell-order">
                                            <thead>
                                                <tr>
                                                    <th className="f14-regular">Name</th>
                                                    <th className="f14-regular">Amount</th>
                                                    <th className="f14-regular">Percentage</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td className="f14-regular"><img src="/images/bep20icone.png" style={{maxHeight: "30px", maxWidth: "30px", marginRight: '5px'}}/>BEP20</td>
                                                    <td className="f14-regular" style={{alignSelf: "end"}}>${dashboard?.payoutDistribution?.BEP20?.amount || 0}</td>
                                                    <td className="f14-regular">{dashboard?.payoutDistribution?.BEP20?.percentage || 0}%</td>
                                                </tr>
                                                <tr>
                                                    <td className="f14-regular"><img src="/images/TRC20icon.png" style={{maxHeight: "30px", maxWidth: "30px", marginRight: '5px'}}/>TRC20</td>
                                                    <td className="f14-regular">${dashboard?.payoutDistribution?.TRC20?.amount || 0}</td>
                                                    <td className="f14-regular">{dashboard?.payoutDistribution?.TRC20?.percentage || 0}%</td>
                                                </tr>
                                                <tr>
                                                    <td className="f14-regular"><img src="/images/ERC20icone.png" style={{maxHeight: "30px", maxWidth: "30px", marginRight: '5px'}}/>ERC20</td>
                                                    <td className="f14-regular">${dashboard?.payoutDistribution?.ERC20?.amount || 0}</td>
                                                    <td className="f14-regular">{dashboard?.payoutDistribution?.ERC20?.percentage || 0}%</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        
                                    </div>
                                </div>

                                <h3 style={{marginBottom: "10px"}}>
                                    Last 10 Transactions
                                </h3>
                                 <div className="table-list-transaction">
                                        <div className="list-transaction-head title-sort">
                                            <div className="btn-key-sort" data-index="0" data-type="string">
                                                <svg width="30" height="20" viewBox="0 0 30 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <rect x="0.5" y="0.5" width="28.6282" height="19" rx="3.5" stroke="white"/>
                                                    <rect x="4.5" y="4.5" width="11" height="11" rx="3.5" stroke="white"/>
                                                    <path d="M23.2115 11.3205L25.0138 8.96357C25.2654 8.63456 25.0308 8.15984 24.6166 8.15984L21.012 8.15984C20.5978 8.15984 20.3632 8.63456 20.6148 8.96357L22.4171 11.3205C22.6173 11.5822 23.0114 11.5822 23.2115 11.3205Z" fill="white"/>
                                                </svg>
                                                <div className="f12-bold text-White">Order ID</div>
                                                <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M7.1618 3.9199C7.1618 4.03073 7.12095 4.14158 7.03345 4.22908C6.86428 4.39825 6.58429 4.39825 6.41512 4.22908L4.55428 2.36825L2.69345 4.22908C2.52428 4.39825 2.24428 4.39825 2.07512 4.22908C1.90595 4.05992 1.90595 3.77992 2.07512 3.61075L4.24514 1.44073C4.3268 1.35906 4.43762 1.31242 4.55428 1.31242C4.67095 1.31242 4.7818 1.35906 4.86347 1.44073L7.03345 3.61075C7.11512 3.69825 7.1618 3.80906 7.1618 3.9199Z" fill="white"/>
                                                    <path d="M4.9917 1.75L4.9917 12.25C4.9917 12.4892 4.79337 12.6875 4.5542 12.6875C4.31503 12.6875 4.1167 12.4892 4.1167 12.25L4.1167 1.75C4.1167 1.51083 4.31503 1.3125 4.5542 1.3125C4.79337 1.3125 4.9917 1.51083 4.9917 1.75Z" fill="white"/>
                                                    <path d="M13.3161 10.08C13.3161 10.1909 13.2752 10.3017 13.1877 10.3892L11.0177 12.5592C10.9361 12.6409 10.8252 12.6875 10.7086 12.6875C10.5919 12.6875 10.4811 12.6409 10.3994 12.5592L8.22941 10.3892C8.06025 10.22 8.06025 9.94 8.22941 9.77083C8.39858 9.60167 8.67858 9.60167 8.84775 9.77083L10.7086 11.6317L12.5694 9.77083C12.7385 9.60167 13.0186 9.60167 13.1877 9.77083C13.2752 9.8525 13.3161 9.96335 13.3161 10.08Z" fill="white"/>
                                                    <path d="M11.1401 1.75L11.1401 12.25C11.1401 12.4892 10.9418 12.6875 10.7026 12.6875C10.4635 12.6875 10.2651 12.4892 10.2651 12.25L10.2651 1.75C10.2651 1.51083 10.4635 1.3125 10.7026 1.3125C10.9418 1.3125 11.1401 1.51083 11.1401 1.75Z" fill="white"/>
                                                </svg>
                                            </div>
                                            <div className="btn-key-sort" data-index="1" data-type="string">
                                                <div className="f12-bold text-White">Date</div>
                                                <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M5.24038 5.32045L8.57191 0.963819C8.82351 0.634814 8.58891 0.160095 8.17473 0.160095L1.51167 0.160095C1.09749 0.160095 0.862898 0.634814 1.11449 0.96382L4.44602 5.32045C4.64614 5.58215 5.04026 5.58215 5.24038 5.32045Z" fill="white"/>
                                                </svg>
                                            </div>
                                            <div className="btn-key-sort" data-index="2" data-type="string">
                                                <div className="f12-bold text-White">Name</div>
                                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M6.53338 3.9199C6.53338 4.03073 6.49253 4.14158 6.40503 4.22908C6.23587 4.39825 5.95587 4.39825 5.7867 4.22908L3.92587 2.36825L2.06503 4.22908C1.89586 4.39825 1.61587 4.39825 1.4467 4.22908C1.27753 4.05992 1.27753 3.77992 1.4467 3.61075L3.61672 1.44073C3.69838 1.35906 3.8092 1.31242 3.92587 1.31242C4.04253 1.31242 4.15338 1.35906 4.23505 1.44073L6.40503 3.61075C6.4867 3.69825 6.53338 3.80906 6.53338 3.9199Z" fill="white"/>
                                                    <path d="M4.36328 1.75L4.36328 12.25C4.36328 12.4892 4.16495 12.6875 3.92578 12.6875C3.68661 12.6875 3.48828 12.4892 3.48828 12.25L3.48828 1.75C3.48828 1.51083 3.68661 1.3125 3.92578 1.3125C4.16495 1.3125 4.36328 1.51083 4.36328 1.75Z" fill="white"/>
                                                    <path d="M12.6876 10.08C12.6876 10.1909 12.6468 10.3017 12.5593 10.3892L10.3893 12.5592C10.3076 12.6409 10.1968 12.6875 10.0802 12.6875C9.9635 12.6875 9.85265 12.6409 9.77098 12.5592L7.601 10.3892C7.43183 10.22 7.43183 9.94 7.601 9.77083C7.77016 9.60167 8.05016 9.60167 8.21933 9.77083L10.0802 11.6317L11.941 9.77083C12.1101 9.60167 12.3902 9.60167 12.5593 9.77083C12.6468 9.8525 12.6876 9.96335 12.6876 10.08Z" fill="white"/>
                                                    <path d="M10.5117 1.75L10.5117 12.25C10.5117 12.4892 10.3134 12.6875 10.0742 12.6875C9.83505 12.6875 9.63672 12.4892 9.63672 12.25L9.63672 1.75C9.63672 1.51083 9.83505 1.3125 10.0742 1.3125C10.3134 1.3125 10.5117 1.51083 10.5117 1.75Z" fill="white"/>
                                                </svg>
                                            </div>
                                            <div className="btn-key-sort" data-index="3" data-type="string">
                                                <div className="f12-bold text-White">Email</div>
                                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M6.53338 3.9199C6.53338 4.03073 6.49253 4.14158 6.40503 4.22908C6.23587 4.39825 5.95587 4.39825 5.7867 4.22908L3.92587 2.36825L2.06503 4.22908C1.89586 4.39825 1.61587 4.39825 1.4467 4.22908C1.27753 4.05992 1.27753 3.77992 1.4467 3.61075L3.61672 1.44073C3.69838 1.35906 3.8092 1.31242 3.92587 1.31242C4.04253 1.31242 4.15338 1.35906 4.23505 1.44073L6.40503 3.61075C6.4867 3.69825 6.53338 3.80906 6.53338 3.9199Z" fill="white"/>
                                                    <path d="M4.36328 1.75L4.36328 12.25C4.36328 12.4892 4.16495 12.6875 3.92578 12.6875C3.68661 12.6875 3.48828 12.4892 3.48828 12.25L3.48828 1.75C3.48828 1.51083 3.68661 1.3125 3.92578 1.3125C4.16495 1.3125 4.36328 1.51083 4.36328 1.75Z" fill="white"/>
                                                    <path d="M12.6876 10.08C12.6876 10.1909 12.6468 10.3017 12.5593 10.3892L10.3893 12.5592C10.3076 12.6409 10.1968 12.6875 10.0802 12.6875C9.9635 12.6875 9.85265 12.6409 9.77098 12.5592L7.601 10.3892C7.43183 10.22 7.43183 9.94 7.601 9.77083C7.77016 9.60167 8.05016 9.60167 8.21933 9.77083L10.0802 11.6317L11.941 9.77083C12.1101 9.60167 12.3902 9.60167 12.5593 9.77083C12.6468 9.8525 12.6876 9.96335 12.6876 10.08Z" fill="white"/>
                                                    <path d="M10.5117 1.75L10.5117 12.25C10.5117 12.4892 10.3134 12.6875 10.0742 12.6875C9.83505 12.6875 9.63672 12.4892 9.63672 12.25L9.63672 1.75C9.63672 1.51083 9.83505 1.3125 10.0742 1.3125C10.3134 1.3125 10.5117 1.51083 10.5117 1.75Z" fill="white"/>
                                                </svg>
                                            </div>
                                            <div className="btn-key-sort" data-index="4" data-type="string">
                                                <div className="f12-bold text-White">Coin</div>
                                                <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M5.24038 5.32045L8.57191 0.963819C8.82351 0.634814 8.58891 0.160095 8.17473 0.160095L1.51167 0.160095C1.09749 0.160095 0.862898 0.634814 1.11449 0.96382L4.44602 5.32045C4.64614 5.58215 5.04026 5.58215 5.24038 5.32045Z" fill="white"/>
                                                </svg>
                                            </div>
                                            <div className="btn-key-sort" data-index="5" data-type="string">
                                                <div className="f12-bold text-White">Amount</div>
                                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M6.53338 3.9199C6.53338 4.03073 6.49253 4.14158 6.40503 4.22908C6.23587 4.39825 5.95587 4.39825 5.7867 4.22908L3.92587 2.36825L2.06503 4.22908C1.89586 4.39825 1.61587 4.39825 1.4467 4.22908C1.27753 4.05992 1.27753 3.77992 1.4467 3.61075L3.61672 1.44073C3.69838 1.35906 3.8092 1.31242 3.92587 1.31242C4.04253 1.31242 4.15338 1.35906 4.23505 1.44073L6.40503 3.61075C6.4867 3.69825 6.53338 3.80906 6.53338 3.9199Z" fill="white"/>
                                                    <path d="M4.36328 1.75L4.36328 12.25C4.36328 12.4892 4.16495 12.6875 3.92578 12.6875C3.68661 12.6875 3.48828 12.4892 3.48828 12.25L3.48828 1.75C3.48828 1.51083 3.68661 1.3125 3.92578 1.3125C4.16495 1.3125 4.36328 1.51083 4.36328 1.75Z" fill="white"/>
                                                    <path d="M12.6876 10.08C12.6876 10.1909 12.6468 10.3017 12.5593 10.3892L10.3893 12.5592C10.3076 12.6409 10.1968 12.6875 10.0802 12.6875C9.9635 12.6875 9.85265 12.6409 9.77098 12.5592L7.601 10.3892C7.43183 10.22 7.43183 9.94 7.601 9.77083C7.77016 9.60167 8.05016 9.60167 8.21933 9.77083L10.0802 11.6317L11.941 9.77083C12.1101 9.60167 12.3902 9.60167 12.5593 9.77083C12.6468 9.8525 12.6876 9.96335 12.6876 10.08Z" fill="white"/>
                                                    <path d="M10.5117 1.75L10.5117 12.25C10.5117 12.4892 10.3134 12.6875 10.0742 12.6875C9.83505 12.6875 9.63672 12.4892 9.63672 12.25L9.63672 1.75C9.63672 1.51083 9.83505 1.3125 10.0742 1.3125C10.3134 1.3125 10.5117 1.51083 10.5117 1.75Z" fill="white"/>
                                                </svg>
                                            </div>
                                            <div className="btn-key-sort" data-index="6" data-type="string">
                                                <div className="f12-bold text-White">Status</div>
                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M17.5 6.4585H2.5C2.15833 6.4585 1.875 6.17516 1.875 5.8335C1.875 5.49183 2.15833 5.2085 2.5 5.2085H17.5C17.8417 5.2085 18.125 5.49183 18.125 5.8335C18.125 6.17516 17.8417 6.4585 17.5 6.4585Z" fill="white"/>
                                                    <path d="M15 10.625H5C4.65833 10.625 4.375 10.3417 4.375 10C4.375 9.65833 4.65833 9.375 5 9.375H15C15.3417 9.375 15.625 9.65833 15.625 10C15.625 10.3417 15.3417 10.625 15 10.625Z" fill="white"/>
                                                    <path d="M11.6668 14.7915H8.3335C7.99183 14.7915 7.7085 14.5082 7.7085 14.1665C7.7085 13.8248 7.99183 13.5415 8.3335 13.5415H11.6668C12.0085 13.5415 12.2918 13.8248 12.2918 14.1665C12.2918 14.5082 12.0085 14.7915 11.6668 14.7915Z" fill="white"/>
                                                </svg>
                                            </div>
                                        </div>
                                        <table className="list-transaction-content content-sort w-100">
                                            <tbody>
                      {dashboard?.last10Transactions?.length > 0 ? (
                        dashboard.last10Transactions.map((tx) => (
                          <tr key={tx.id} className="tf-table-item">
                            <td>#{tx.order_id}</td>
                            <td>
                              {new Date(tx.created_at).toLocaleDateString()} <br />
                              <span className="f12-medium">{new Date(tx.created_at).toLocaleTimeString()}</span>
                            </td>
                            <td>{tx.name}</td>
                            <td>{tx.email}</td>
                            <td>{tx.chain.toUpperCase()}</td>
                            <td>${tx.amount}</td>
                            <td className={`box-status ${
                                  tx.status.toLowerCase() === "complete"
                                    ? "bg-YellowGreen"
                                    : tx.status.toLowerCase() === "failed"
                                    ? "bg-LightGray type-red"
                                    : "bg-LightGray"
                                }`}>
                              
                                <span className="font-poppins">{tx.status}</span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="8" style={{ textAlign: "center" }}>
                            No transactions found
                          </td>
                        </tr>
                      )}
                    </tbody>
                                        </table>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default Dashboard;
